module.exports = __webpack_public_path__ + "media/img/apple-icon-120x120-92c3ebe1f6346960b2fbd781362965c2.png";